'use strict';

module.exports = {
  template: require('./auth-accept.html'),
  controller: require('./auth-accept.controller.js'),
  controllerAs: 'vm',

  bindings: {
    invite: '<'
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/auth/auth-accept/index.js
 ** module id = 176
 ** module chunks = 0
 **/